// Project.js
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import {
  faServer,
  faLink,
  faCircleInfo,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Card, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import './Project.css';

const Project = ({ myProject }) => {
  const { id, name, clientSite, serverSite, liveSite, details, banner, tools } =
    myProject;

  const navigate = useNavigate();
  const navigateToProjectDetail = (id) => {
    navigate(`/project/${id}`);
  };

  return (
    <Card
      className="project-card mt-5 p-0 border-5 shadow-lg mx-auto"
      style={{ width: '24rem', backgroundColor: 'transparent' }}>
      {/* backgroundColor: "#112240" */}
      <a
        href={liveSite}
        target="_blank"
        className="text-decoration-none"
        rel="noreferrer">
        <Card.Img
          variant="top"
          src={banner}
          style={{
            height: '12rem',
            objectFit: 'cover',
            objectPosition: 'top',
          }}
        />

        <Card.Body className="pb-0">
          <Card.Title className="text-start">
            <h3 className="title-color">{name}</h3>
          </Card.Title>
          <Card.Text className="description">
            <strong>Stack: </strong> {tools}
            <p className="mb-0">
              <strong>Show Details:</strong> {details.slice(0, 50)}...
            </p>
          </Card.Text>
        </Card.Body>
        <Card.Body className="pt-0">
          <div className="live-link-container">
            <Card.Link>
              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Tooltip id="button-tooltip-2">Client Site Code link</Tooltip>
                }>
                {({ ref, ...triggerHandler }) => (
                  <a
                    {...triggerHandler}
                    href={clientSite}
                    target="_blank"
                    rel="noopener noreferrer">
                    <span ref={ref} className="project-link">
                      <FontAwesomeIcon
                        icon={faGithub}
                        className="footer-icon"
                      />
                    </span>
                  </a>
                )}
              </OverlayTrigger>
            </Card.Link>
            <Card.Link>
              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Tooltip id="button-tooltip-2">Server Site Code link</Tooltip>
                }>
                {({ ref, ...triggerHandler }) => (
                  <a
                    {...triggerHandler}
                    href={serverSite}
                    target="_blank"
                    rel="noopener noreferrer">
                    <span ref={ref} className="project-link">
                      <FontAwesomeIcon
                        icon={faServer}
                        className="footer-icon"
                      />
                    </span>
                  </a>
                )}
              </OverlayTrigger>
            </Card.Link>
            <Card.Link>
              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Tooltip id="button-tooltip-2">Live Site Code link</Tooltip>
                }>
                {({ ref, ...triggerHandler }) => (
                  <a
                    {...triggerHandler}
                    href={liveSite}
                    target="_blank"
                    rel="noopener noreferrer">
                    <span ref={ref} className="project-link live-link-icon">
                      <FontAwesomeIcon icon={faLink} className="footer-icon" />
                    </span>
                  </a>
                )}
              </OverlayTrigger>
            </Card.Link>
            <Card.Link>
              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Tooltip id="button-tooltip-2">Projects Details</Tooltip>
                }>
                {({ ref, ...triggerHandler }) => (
                  <a
                    {...triggerHandler}
                    target="_blank"
                    rel="noopener noreferrer">
                    <span ref={ref} className="project-link">
                      <FontAwesomeIcon
                        icon={faCircleInfo}
                        className="footer-icon"
                        onClick={() => navigateToProjectDetail(id)}
                      />
                    </span>
                  </a>
                )}
              </OverlayTrigger>
            </Card.Link>
          </div>
        </Card.Body>
      </a>
    </Card>
  );
};

export default Project;
